/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../api/index';
import * as core from '../../../../core';
import * as serializers from '../../../index';

export const PresentationIssueRequestDidMethod: core.serialization.Schema<
    serializers.PresentationIssueRequestDidMethod.Raw,
    Truvity.PresentationIssueRequestDidMethod
> = core.serialization.enum_(['key', 'web']);

export declare namespace PresentationIssueRequestDidMethod {
    export type Raw = 'key' | 'web';
}
